import { render, staticRenderFns } from "./details-memory.vue?vue&type=template&id=4f99fb5e&"
import script from "./details-memory.vue?vue&type=script&lang=js&"
export * from "./details-memory.vue?vue&type=script&lang=js&"
import style0 from "./details-memory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports